import { render, staticRenderFns } from "./NationalTrademarkRenewalsForm.vue?vue&type=template&id=931558a2&"
import script from "./NationalTrademarkRenewalsForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkRenewalsForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkRenewalsForm.vue?vue&type=style&index=0&id=931558a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports